export const altCharacterDescription = "Description not provided"

export const  altCharacterName = "Name not provided"